import { createFeatureSelector, createSelector } from '@ngrx/store';
import { REPORTS_STORE_KEY, IDailyReportState } from './reports-store.state';

const state = createFeatureSelector<IDailyReportState>(REPORTS_STORE_KEY);

export const reportsState = createSelector(state, (state1: IDailyReportState) => state1);
export const isLoadingReport = createSelector(state, (state1: IDailyReportState) => state1.isLoading);
